/* eslint-disable import/prefer-default-export */
import constants from "../constants";

const { UPDATE_DEVICE, CLEAN_STATE } = constants;

export const updateThermostatIp = (data) => ({
  type: UPDATE_DEVICE,
  data,
});

export const cleanThermostatIpReducer = () => ({
  type: CLEAN_STATE,
});
